import { render, staticRenderFns } from "./HaveChild.vue?vue&type=template&id=4605f026&scoped=true"
import script from "./HaveChild.vue?vue&type=script&lang=js"
export * from "./HaveChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4605f026",
  null
  
)

export default component.exports